<template>
  <thead>
    <tr v-if="showMenu"
        class="table-heading"
    >
      <td>
        <ContextMenu
          :items="menuItems"
        >
          <template #icon>
            <i class="fas fa-bars asd-btn-single-icon"></i>
          </template>
        </ContextMenu>
      </td>
      <td :colspan="columns.length - 1">
        <slot name="default"></slot>
      </td>
    </tr>
    <tr class="table-heading">
      <th v-for="(col, i) in columns"
          :key="col.key"
          :class="{active_asc: (col.key === column && order === 'asc'), active_desc: (col.key === column && order === 'desc')}"
          @click="changeSorter(col.key)"
      >
        {{ col.label }}
        <template v-if="col.key !== null">
          <sorter v-if="col.key == column"
                  :key="order"
                  :direction="order"
          ></sorter>
          <span v-if="col.key != column"><i class="fas fa-sort"></i></span>
        </template>
        <template v-else-if="addButton !== null && i === 0">
          <router-link :to="addButton">
            <button class="asd-btn-confirm asd-btn-single-icon">
              <i class="fas fa-plus"></i>
            </button>
          </router-link>
        </template>
      </th>
    </tr>
  </thead>
</template>

<script>
import _ from 'lodash'
import sorter from '@/modules/core/components/table-view/sorter.vue'
import ContextMenu from 'CORE/components/context-menu'

const transformAdditionalCol = col => {
    if (col === null) return { label: null, key: null }
    return col
}

export default {
    name: 'TableHeading',
    components: {
        sorter,
        ContextMenu,
    },
    props: {
        leadingCols: {
            type: Array,
            required: false,
            default: _ => [],
        },
        trailingCols: {
            type: Array,
            required: false,
            default: _ => [],
        },
        cols: {
            type: Array,
            required: true,
            default: _ => [],
        },
        projectFilterEnabled: {
            required: false,
            type: Boolean,
            default: _ => false,
        },
        defaultSorter: {
            type: Object,
            required: false,
            default: _ => {return {}},
        },
        userSorter: {
            type: Object,
            required: false,
            default: _ => {return {}},
        },
        addButton: {
            type: Object,
            required: false,
            default: _ => null,
        },
        menuItems: {
            type: Array,
            required: false,
            default: _ => [],
        },
    },
    data() {
        return {
            column: undefined,
            order: 'asc',
        }
    },
    computed: {
        columns() {
            return [
                ..._.map(this.leadingCols, transformAdditionalCol),
                ..._.map(this.cols, key => {
                    const pt = this.$store.getters.propertyTypeByKey(key)
                    return {
                        label: pt.name,
                        key,
                    }
                }),
                ..._.map(this.trailingCols, transformAdditionalCol),
            ]
        },
        columnsPropertyValues() {
            return _.map(this.cols, c => {
                return this.$store.getters.propertyTypeByKey(c)
            })
        },
        showMenu() {
            const slotsCount = _.size(this.$slots)
            const menuItemsCount = _.size(this.menuItems)
            return slotsCount + menuItemsCount > 0
        },
    },
    watch: {
        userSorter(newVal, oldVal) {
            this.column = _.get(newVal, 'column', undefined)
            this.order = _.get(newVal, 'order', 'asc')
        },
    },
    mounted() {
        if (_.size(this.userSorter)) {
            this.column = _.get(this.userSorter, 'column', undefined)
            this.order = _.get(this.userSorter, 'order', 'asc')
            console.info('userSorter', this.column, this.order)
        } else if (_.size(this.defaultSorter)) {
            this.column = _.get(this.defaultSorter, 'column', undefined)
            this.order = _.get(this.defaultSorter, 'order', 'asc')
            this.$emit('sorter-changed', { column: this.column, order: this.order })
        }
    },
    methods: {
        changeSorter(column) {
            if (column === null) return
            if (column === this.column) {
                if (this.order === 'asc') {
                    this.order = 'desc'
                } else {
                    this.order = 'asc'
                }
            } else {
                this.column = column
                this.order = 'asc'
            }
            this.$emit('sorter-changed', { column: this.column, order: this.order })
        },
    },
}
</script>
